/**
 * Contains adobe specific configuration items, which is exported and passed to components
 */
 
const AdobeEventRegister = {
    pageLoadEvent: {
        eventName: "pageView",
    },    
    generalEvents: {
        genaricLinkCLick: {
            eventName: "Link Tracking",
        }

    },
    footer: {
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Bottom Navigation Bar"
        }
    },
    homeButton: {
        title: "Data Explorer",
        titleHome: "Home",
        componentlinkIdentifier: "Home Page",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    requestsButton: {
        title: "Requests",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    dashboardButton: {
        title: "Dashboard",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    allData: {
        title: "All Data",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    whatsNew: {
        title: "What's New",
        announcement: "What's New Announcement",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    newJoiner: {
        title: "New Joiner",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    dataProduct: {
        title: "Data Product",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Homepage: My Data"
        }
    },
    myDashboard: {
        title: "My Dashboard",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "My Dashboard-Top Nav Bar"
        }
    },
    dataProductRequestForm: {
        title: "Data Product",
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Home Page Data Product Link"
        },
        submitClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Home: Request New Data Product"
        },
        submitCloseClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Data Product Request Page Submit Cancel Link"
        },
        cancelYesClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Home: Request New Data Product"
        },
        cancelNoClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Data Product Request Page Cancel(No) Link"
        }
    },
    card: {
        cardClick: {
            eventName: "SelectSearchResult",
            componentlinkIdentifier: "Detailed View"
        }
    },
    cartCompare: {
        compareIconClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "View Cart",
            clickedItem: "View Cart: Compare"
        },
        compareButtonClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "View Cart: Compare",
            clickedItem: "View Cart",
            compareCartName: "View Cart: Compare"
        },
        titleClick: {
            eventName: "DocumentView",
            componentlinkIdentifier: "Detailed View",
            clickedItem: "View Cart: Compare: Title"
        },
        cartIconClick:{
            componentlinkIdentifier: "Top Navigation Bar",
            clickedItem: "View Cart"
        }
    },
    filterPill: {
        title:"Search Filter: pill click",
        eventName: "clickAction",
        homepage: "Homepage",
        ResultsPage: "Results Page"
    },
    filter: {
        title:"Search Filter: drop-down click",
        eventName: "clickAction",
        homepage: "Homepage",
        ResultsPage: "Results Page"
    },
    sort: {
        title:"Search Sort Order",
        eventName: "clickAction",
        ResultsPage: "Results Page",
        RecentlyViewed: "Recently Viewed",
        HomePageData: "Homepage: My Data"
    },
    cardContainer: {
        title:"Card View",
        ResultsPage: "Results Page",
        RecentlyViewed: "Recently Viewed",
        linkClick: {
            eventName: "Link Tracking",
            clickedItem: "Search Results",
            componentlinkIdentifier: "Result Page"
        },
        HomePageData: "Homepage: My Data"
    },
    list: {
        listClick: {
            eventName: "SelectSearchResult",
            componentlinkIdentifier: "Detailed View"
        },
        cartClick:{
            eventName: "SelectCart",
            componentlinkIdentifier: "List: SelectCart"
        }
    },
    listContainer: {
        title:"List View",
        ResultsPage: "Results Page",
        RecentlyViewed: "Recently Viewed",
        linkClick: {
            eventName: "Link Tracking",
            clickedItem: "Search Results",
            componentlinkIdentifier: "Result Page"
        },
        HomePageData: "Homepage: My Data"
    },
    navigation: {
        linkClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Top Navigation Bar"
        }
    },
    searchBox: {
        id: "#data-search",
        searchClick: {            
            eventName: "CompletedSiteSearch",
            searchMenuItem: "Data Explorer Search Result Click",
            componentlinkIdentifier: "Search Result Page"
        },
        suggessionSearchClick: {            
            eventName: "CompletedSiteSearch",
            searchMenuItem: "Data Explorer Search Result Click",
            componentlinkIdentifier: "Search: Suggested"
        },
        searchClickNoResult:{
            eventName: "NoSearchResultFound",
            searchMenuItem: "Data Explorer No Search result found"
        },
        homePageSearchClick: {
            componentlinkIdentifier: "Homepage"
        }
    },
    topicCard: {
        cardClick: {
            eventName: "SelectSearchResult",
            componentlinkIdentifier: "Detailed View"
        }
    },
    homePage: {
        viewMoreClick: {
            eventName: "Link Tracking"
        },
       homePageData: "Homepage: My Data" 
    },
    details: {
        requestAction: {
            eventName: "DocumentView",
            customAckEventName: "Acknowledged",
            detailviewIdentifier : "Detailed View",  
            aknowledgeIdentifier : "Content Detail Page",          
            requestAccess: {
                componentlinkIdentifier: "Detailed View: Knowledge Share Tab"
            },
            requestAccessBtn: {
                linkName: "Request Access",
            },
            accessBtn: {
                linkName: "Access",
            },
            downloadBtn: {
                linkName: "Download",
            },
            acknowledgeBtn: {
                linkName: "Acknowledged",
                componentlinkIdentifier: "Content Detail Page"
            },
            closeBtn: {
                linkName: "Closed",
                componentlinkIdentifier: "Terms of Use"
            }
        },
        tabClick: {
            eventName: "clickAction",
            componentlinkIdentifier: "Detailed View: Knowledge Asset Tabs"
        },
        copyURLClick: {
            eventName: "DocumentView",
            componentlinkIdentifier: "Detailed View: Knowledge Share Tab",
        },
        pageLoad: {
            eventName: "Page Load",
        },
        providerURLClick: {
            eventName: "DocumentView",
            componentlinkIdentifier: "Detailed View: Other link interaction",
        },
        collateralDownloadClick: {
            eventName: "DocumentDownload",
            componentlinkIdentifier: "Detailed View: Collateral Data"
        },
        contactCardClick: {
            eventName: "Link Tracking",
            profileLink: "Profile link",
            componentlinkIdentifier: "Detailed View: Contacts"
        },
        downloadCLick: {
            eventName: "DocumentDownload",
            componentlinkIdentifier: "Detailed View"

        },
        shareTeamsClick: {
            eventName: "DocumentView",
            componentlinkIdentifier: "Detailed View: Knowledge Share Tab",
            shareToTeams: "Share to Teams"
        },
        viewMore: {
            eventName: "DocumentView",
            viewMoreText: "View More",
            componentlinkIdentifier: "Detailed View: Other link interaction"
        },
        compareIconClick: {
            eventName: "Link Tracking",
            componentlinkIdentifier: "Detailed View:Add to Cart",
            clickedItem: "Top Navigation Bar"
        },
    },
    refiners: {
        eventName: "SearchRefinement",
        componentlinkIdentifier: "Search Refiner",
        type: "Apply Filter",
        data: "Data"
    },
    detailsPage: {
        cardView: {
            eventName: "DocumentView",
            componentlinkIdentifier: "Detailed View"
        },
        PageView: {
            eventName: "pageView",
            componentlinkIdentifier: "Detailed View"
        }
    },
    resultPage: {
        cardView: {
            eventName: "DocumentView",
            componentlinkIdentifier: "Detailed View"
        }
    },
    topicRefiners:{
        eventName: "CompletedSiteSearch",
        componentlinkIdentifier: "Homepage: Topic",
        queryText: "*",
        searchMenuItemName: "Search"
    }    
};

export default AdobeEventRegister;